export function getView(treatment_plan_groups) {
  return treatment_plan_groups.some(item => item.id !== 0)
}
